import { Colors } from '../consts/Colors';

export default class CircularAudioPlayer extends Phaser.GameObjects.Container {
    constructor(
        scene,
        x,
        y,
        audioKey,
        imgKey,
        radius = 50,
        stroke = 10,
        playerIndex,
        activeIndex = 0
    ) {
        super(scene, x, y);
        this.scene = scene;
        this.audioKey = audioKey;
        this.imgKey = imgKey;
        this.radius = radius;
        this.stroke = stroke;
        this.isPlaying = false;
        this.playerIndex = playerIndex;
        this.activeIndex = activeIndex;

        // === Circle base ===
        this.baseCircle = scene.add.graphics();
        this._drawBaseCircle(Colors.Elmt.BleuNovotel, 1);
        this.add(this.baseCircle);

        // === Progress arc
        this.progressCircle = scene.add.graphics();
        this.add(this.progressCircle);

        // === Icon
        this.iconPlay = scene.add.image(0, 0, 'audio-play').setOrigin(0.5).setScale(1);
        this.add(this.iconPlay);

        // Pointer handler (ajouté UNE seule fois)
        this.iconPlay.on('pointerdown', () => this.toggleAudio());

        // === Son
        this.sound = scene.sound.add(audioKey, { volume: 1 });
        this.sound.on('complete', () => this.resetPlayer());

        // Applique les règles d'interactivité dès la création
        this.updateInteractivity();

        scene.add.existing(this);
    }

    // Appelé quand l'index actif change (depuis la scène)
    setActiveIndex(newIndex) {
        this.activeIndex = newIndex;
        this.updateInteractivity();
    }

    // Règles d'interactivité + opacité
    updateInteractivity() {
        const level0 = this.scene.game?.data?.level === 0;
        const isActive = this.playerIndex === this.activeIndex;

        // Nettoie l'état d'interactivité pour éviter les doublons
        this.iconPlay.disableInteractive();
        this.removeAllListeners('pointerdown'); // listeners du Container
        this.iconPlay.removeAllListeners('pointerdown'); // listeners de l'icon (sécurité)
        this.iconPlay.on('pointerdown', () => this.toggleAudio()); // ré-attache 1 fois

        if (level0) {
            if (isActive) {
                this.iconPlay.setInteractive({ cursor: 'pointer' });
                this.iconPlay.setAlpha(1);
                this._drawBaseCircle(Colors.Elmt.BleuNovotel, 1);
                this.baseCircle.setAlpha(1);
            } else {
                // non-actifs: demi-opacité et non cliquables
                this.iconPlay.setAlpha(0.5);
                this._drawBaseCircle(Colors.Elmt.White, 1);
                this.baseCircle.setAlpha(0.5);
                this.iconPlay.disableInteractive();
            }
        } else {
            // niveau != 0 : tout cliquable et opaque
            this.iconPlay.setInteractive({ cursor: 'pointer' });
            this.iconPlay.setAlpha(1);
            this._drawBaseCircle(Colors.Elmt.BleuNovotel, 1);
            this.baseCircle.setAlpha(1);
        }
    }

    // utilitaire : comme tu changes le lineStyle après coup, il faut re-stroker
    _drawBaseCircle(color, alpha = 1) {
        this.baseCircle.clear();
        this.baseCircle.lineStyle(this.stroke, color, alpha);
        this.baseCircle.strokeCircle(0, 0, this.radius);
    }

    toggleAudio() {
        if (this.isPlaying) {
            this.sound.pause();
            this.iconPlay.setTexture('audio-play');
            this.isPlaying = false;
            this.scene.game.data.currentImage = '';
        } else {
            this.scene.game.data.currentImage = this.imgKey;
            if (!this.sound.isPlaying && this.sound.seek === 0) {
                this.sound.play();
            } else {
                this.sound.resume();
            }
            this.iconPlay.setTexture('audio-wave');
            this.isPlaying = true;
        }
    }

    resetPlayer() {
        this.isPlaying = false;
        this.iconPlay.setTexture('audio-play');
        this.sound.stop();
        this.sound.seek = 0;
        this.drawProgressArc(0);
    }

    update() {
        if (this.isPlaying && this.sound.isPlaying) {
            const progress = this.sound.seek / this.sound.duration;
            this.drawProgressArc(progress);
        }
    }

    drawProgressArc(progress) {
        const g = this.progressCircle;
        g.clear();
        g.lineStyle(this.stroke, 0xffffff, 1);
        g.beginPath();
        g.arc(0, 0, this.radius, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2, false);
        g.strokePath();
    }
}
